import type { IssueStatus } from '@/types/issue';

interface Props {
  status: IssueStatus | string;
  size?: number;
  className?: string;
}

export default function StatusIcon({ status, size = 14, className }: Props) {
  const title = status.replace(/_/g, ' ');

  if (status === 'backlog') {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" className={className} aria-label={title}>
        <circle
          cx="8"
          cy="8"
          r="6"
          fill="none"
          stroke="#6b6f76"
          strokeWidth="1.5"
          strokeDasharray="2.2 2"
        />
      </svg>
    );
  }

  if (status === 'todo') {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" className={className} aria-label={title}>
        <circle cx="8" cy="8" r="6" fill="none" stroke="#97979a" strokeWidth="1.5" />
      </svg>
    );
  }

  if (status === 'in_progress') {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" className={className} aria-label={title}>
        <circle cx="8" cy="8" r="6" fill="none" stroke="#f0bf00" strokeWidth="1.5" />
        <path d="M8 2 A6 6 0 0 1 14 8 L8 8 Z" fill="#f0bf00" />
      </svg>
    );
  }

  if (status === 'in_review') {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" className={className} aria-label={title}>
        <circle cx="8" cy="8" r="6" fill="none" stroke="#27a644" strokeWidth="1.5" />
        <path d="M8 2 A6 6 0 1 1 2 8 L8 8 Z" fill="#27a644" />
      </svg>
    );
  }

  if (status === 'done') {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" className={className} aria-label={title}>
        <circle cx="8" cy="8" r="7" fill="#5e6ad2" />
        <path
          d="M5 8.2 L7.1 10.3 L11.2 5.7"
          fill="none"
          stroke="#f7f8f8"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 16 16" className={className} aria-label={title}>
      <circle cx="8" cy="8" r="7" fill="#6b6f76" />
      <path
        d="M5.5 5.5 L10.5 10.5 M10.5 5.5 L5.5 10.5"
        stroke="#121213"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
